import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class TaxRateForm extends BaseModel {
  tax_rate = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    tax_rate: 'required|max_value:100|min_value:0'
  };

  attributeLabels = {
    tax_rate: i18n.t('Tax Rate'),
  };
}
